module.exports = __webpack_public_path__ + "img/electric_pending_zone.2f7bd33d.svg";